<ng-container *ngIf="!finished">
    <div id="loading-js" *ngIf="isLoading" class="loading-js">
        <div class="loader">
            <img class="" src="./assets/img/loader.svg" width="60" alt="">
        </div>
    </div>
    <div class="stepline"></div>
    <mat-horizontal-stepper [@.disabled]="true" labelPosition="bottom" #stepper="matHorizontalStepper" id="rm-mat-stepper" class="row rm-steppper"
                            [linear]="true" [disableRipple]="true" (selectionChange)="onStepChange()">
        <ng-template matStepperIcon="edit" let-index="index">{{index + 1}}</ng-template>
        <app-rm-modal-save></app-rm-modal-save>
        <mat-step [stepControl]="fibraFormGroup" label="Fibra" state="number"
                  [editable]="isEditable"
                  *ngIf="typeOrder === 'convergent' || typeOrder === 'broadband'">
            <div class="container content">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <h5 class="title-step" align="center">
                            <img src="./assets/img/map-pin.svg" class="img-fluid ico-title" width="20">
                            Dirección de instalación
                        </h5>

                        <div class="jumbotron-norm" style="margin-bottom: 4rem!important;" *ngIf="this.muestraNormalizacion == true">
                            <app-rm-normaliza-direccion [formGroup]="normalizadorFormGroup"></app-rm-normaliza-direccion>
                            <app-rm-cobertura [formGroup]="coberturaFormGroup"></app-rm-cobertura>
                        </div>

                        <div *ngIf="this.muestraNormalizacion == false">
                            <app-resultado class="rm"></app-resultado>
                            <div id="Errores_ninguna" *ngIf="amenaRealtechnology === null && muestraErrorPeticion">
                                <mat-error>
                                    <p class="alert alert-warning bg-green text-center" style="display: flex; flex-wrap: wrap; padding-top: 0.75rem;" [innerHTML]="msgErrorPeticion"></p>
                                </mat-error>
                            </div>

                            <div class="mt-2 mb-5" *ngIf="amenaRealtechnology === false && !thereIsCoverage">
                                <h5 align="center" class="tar-name-preload">Consultando cobertura...</h5>

                                <div align="center">
                                    <img class="" src="./assets/img/spinner_rm.svg" width="30" alt="Cargando...">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" *ngIf="this.muestraNormalizacion == false && this.thereIsCoverage == true && rate == null">
                        <app-rm-rates></app-rm-rates>
                    </div>

                    <div class="col-md-8 offset-md-2"
                         *ngIf="this.muestraNormalizacion == false && msgErrorPeticion != null && msgErrorPeticion != '' && !thereIsCoverage && amenaRealtechnology && rate == null">
                        <hr class="mb-5">

                        <div class="jumbotron-norm p-4 mb-5">
                            <div class="row">
                                <div class="col-12">
                                    <h4><strong style="font-size: 1.3rem">Sin cobertura de República Móvil</strong></h4>
                                </div>

                                <div class="col-12 mt-3 mb-3">
                                    <p *ngIf="typeOrder === orderType.CONVERGENT">
                                        En la dirección indicada no hay cobertura de República Móvil. Puedes continuar la contratación con Amena.
                                        Estas son las opciones en la dirección del cliente:
                                    </p>
                                    <p *ngIf="typeOrder === orderType.BROADBAND">
                                        En la dirección indicada no hay cobertura de República Móvil. Puedes realizar una contratación Fijo y
                                        Móvil con Amena. Accede a las tarifas que tienes disponibles.
                                    </p>
                                </div>

                                <div class="col-12">
                                    <div class="card--tarifas--digo mb-2">
                                        <div class="row">
                                            <div class="col-12">
                                                <img src="./assets/img/am-login-color.svg" class="img-fluid" width="140px"
                                                     style="margin-bottom: -10px; margin-top: 12px">
                                            </div>

                                            <div class="col-md-6">
                                                <div class="card-body--digo">
                                                    <h6 class="ms-1 marca--sub">Tipo de cobertura:</h6>

                                                    <div align="center" class="btn-group">
                                                        <div class="btn btn-gray--round dark btn-sm me-1" *ngFor="let technology of amenaRealtechnology" [hidden]="!technology.real">
                                                            {{ realTechnologyNames[technology.access] }}                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 d-md-flex align-items-md-end">
                                                <div class="card-body--digo">
                                                    <!-- Oferta -->
                                                    <h6 class="ms-1 marca--sub" *ngIf="typeOrder === orderType.CONVERGENT">Contratación Amena:</h6>

                                                    <!-- Button group -->
                                                    <div align="center" class="btn-group mt-2">
                                                        <a href="{{ baseUrl }}amena_activa.itx?convergente=1" class="btn btn-black--outline btn-sm ms-1"
                                                           *ngIf="typeOrder === orderType.CONVERGENT">
                                                            Contratación de Fijo y móvil
                                                        </a>
                                                        <a (click)="goToAmenaConvergente()" class="btn btn-black--outline btn-sm ms-1"
                                                           *ngIf="typeOrder === orderType.CONVERGENT && !enviroment.production">
                                                           (Solo int) Contratación de Fijo y móvil (N)
                                                        </a>
                                                        <button (click)="goToHomeRates()" class="btn btn-black--outline btn-sm ms-1"
                                                           *ngIf="typeOrder === orderType.BROADBAND">
                                                            Consultar tarifas
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <ng-container *ngIf="rate">
                        <ng-container *ngIf="typeOrder !== 'convergent'; then othersResult else convergentResult"></ng-container>
                    </ng-container>

                </div>
            </div>
        </mat-step>

        <mat-step *ngFor="let mobilePackForm of this.movilPackForms.controls; let i = index"
                  [editable]="isEditable"
                  [stepControl]="mobilePackForm"
                  label="{{ i == 0 ? 'Móvil principal' : (i + 1) + 'º linea móvil' }}"
                  state="number">
            <app-rm-movil-pack [index]="i" [formGroup]="mobilePackForm" [stepper]="stepper" (requestAddMobileLine)="addMobilePack()"></app-rm-movil-pack>
        </mat-step>

        <mat-step [stepControl]="clienteFormGroup" [editable]="isEditable" label="Cliente" state="number">
            <app-rm-user-data [formGroup]="clienteFormGroup" [stepper]="stepper"></app-rm-user-data>
        </mat-step>

        <mat-step [stepControl]="confirmacionFormGroup" [editable]="isEditable" label="Confirmación" state="number">
            <app-rm-confirmation (onActivationRequest)="onActivationRequest($event)"></app-rm-confirmation>

        </mat-step>
    </mat-horizontal-stepper>
</ng-container>
<ng-container *ngIf="finished">
    <app-rm-finished></app-rm-finished>
</ng-container>


<!-- PLANTILLAS -->

<!-- No convergente -->
<ng-template #othersResult>
    <div class="col-lg-12 mt-3">
        <h5 class="title-step" align="center">
            <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
            Tarifa Fibra
        </h5>
        <div class="card card-default card-horizontal mb-3">
            <div class="card-heading">
                <div class="row">
                    <div class="col-lg-6">
                        <h5 align="left" class="tar-name car-tar-1">{{ rate.name }}</h5>
                    </div>
                    <div class="col-lg-6">
                        <h5 align="left" class="tar-price car-tar-2">{{ priceWithIVA(rate.rateAmount).toFixed(0) }}<span>€/mes</span></h5>
                    </div>
                </div>

            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-5">
                        <h5 align="left" class="tar-name-5 pt-1" *ngIf="rate.resumeLabelData">
                            <b>{{ rate.resumeLabelData }}</b>
                        </h5>
                    </div>
                    <div class="col-md-auto"><span class="vl mobile"></span></div>
                    <div class="col-md-5">
                        <h5 align="left" class="tar-name-5 pt-1">
                            <b>INSTALACIÓN GRATIS</b>
                        </h5>
                        <h5 align="left" class="tar-name-5 pt-1">
                            <b>ROUTER EN CESIÓN GRATIS</b>
                        </h5>
                    </div>
                    <div class="col-md-1 btn-change align-self-center">
                        <a class="btn btn-green btn-sm" (click)="changeRate()">Cambiar</a>
                    </div>
                </div>
            </div>
        </div>

        <div align="center">
            <br>
            <a (click)="next()" class="btn btn-black btn-block mb-1" role="button">
                Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
            </a>
            <br>
        </div>
    </div>
</ng-template>

<!--convergente-->
<ng-template #convergentResult>
    <div class="col-lg-12 mt-3">
        <h5 class="title-step" align="center"><img src="./assets/img/package.svg" class="img-fluid ico-title" width="20"> Ofertas para el cliente</h5>
        <div class="card card-default card-horizontal mb-3">
            <div class="card-heading">
                <div class="row">
                    <div class="col-lg-6 align-self-center">
                        <h5 align="left" class="tar-name car-tar-1">{{ rate?.name }} + {{ mobileRates[0]?.name }}</h5>
                    </div>
                    <div class="col-lg-6">
                        <h5 align="left" class="tar-price car-tar-2">
                            {{ priceConvergent(+rate?.rateAmount, rate?.discount, mobileRates[0]?.rateAmount).toFixed(0) }}
                            <span>€/mes</span>
                        </h5>
                    </div>
                </div>

            </div>
            <div class="card-body">
                <div class="row" *ngIf="rate">
                    <div class="col-md-5">
                        <h5 align="left" class="tar-name-5 pt-1" *ngIf="rate.resumeLabelData">
                            <b>{{ rate.resumeLabelData }}</b>
                        </h5>
                        <h5 align="left" class="tar-name-5 pt-1">
                            <b>INSTALACIÓN GRATIS</b>
                        </h5>
                        <h5 align="left" class="tar-name-5 pt-1">
                            <b>ROUTER EN CESIÓN GRATIS</b>
                        </h5>
                    </div>
                    <div class="col-md-auto"><span class="vl mobile"></span></div>
                    <div class="col-md-5">
                        <h5 align="left" class="tar-name-5 pt-1" *ngIf="mobileRates[0] && (mobileRates[0].labelData || mobileRates[0].sublabelData)">
                            {{ mobileRates[0]?.labelData }} <b>{{ mobileRates[0]?.sublabelData }}</b>
                        </h5>
                        <h5 align="left" class="tar-name-5 pt-1" *ngIf="mobileRates[0] && mobileRates[0].resumeLabelVoice">
                            {{ mobileRates[0].resumeLabelVoice }}
                        </h5>
                    </div>
                    <div class="col-md-1 btn-change align-self-center">
                        <a class="btn btn-green btn-sm" (click)="changeRate()">Cambiar</a>
                    </div>
                </div>
            </div>
        </div>

        <div align="center">
            <br>
            <a (click)="next()" class="btn btn-black btn-block mb-1" role="button">
                Continuar <img src="./assets/img/arrow-right-white.svg" class="img-fluid ico-title" width="15">
            </a>
            <br>
        </div>
    </div>
</ng-template>
